import { render } from "./Explorer.vue?vue&type=template&id=437bfc25&ts=true"
import script from "./Explorer.vue?vue&type=script&lang=ts"
export * from "./Explorer.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\ProjectsLaravel\\nft_imw_v2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/ts/frontend/views/Explorer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "437bfc25"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('437bfc25', __exports__)) {
    console.log('reload')
    api.reload('437bfc25', __exports__)
  }
  
  module.hot.accept("./Explorer.vue?vue&type=template&id=437bfc25&ts=true", () => {
    console.log('re-render')
    api.rerender('437bfc25', render)
  })

}


export default __exports__